var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "portfolio" }, [
    _c("div", { staticClass: "container-header" }, [
      _c("div", { staticClass: "container-header__title" }, [
        _vm._v(" " + _vm._s(_vm.i18n.lbl_investment_portfolio()))
      ])
    ]),
    _vm._v(" "),
    _vm.tokens
      ? _c("div", { staticClass: "portfolio__columns" }, [
          _c(
            "div",
            { staticClass: "portfolio__left-col" },
            [
              _c("portfolio-list", {
                attrs: { tokens: _vm.tokens },
                on: { "show-details": _vm.setCurrentAsset }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "portfolio__right-col" },
            [
              _c("portfolio-details", { attrs: { token: _vm.currentAsset } }),
              _vm._v(" "),
              _c("portfolio-transactions", {
                attrs: { token: _vm.currentAsset }
              })
            ],
            1
          )
        ])
      : _c(
          "div",
          [
            _c("not-available-card", {
              staticClass: "portfolio__not-available",
              attrs: {
                icon: "work",
                title: _vm.i18n.lbl_no_investment_tokens(),
                descr: _vm.i18n.lbl_no_investment_tokens_desc()
              }
            })
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f7a60e5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f7a60e5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/portfolio/Portfolio.Index.vue
// module id = E8nY
// module chunks = 1